import { GenericObject } from "custom-types/generic-object";

export function generateUrlParamsFromObject(obj: GenericObject) {
    let paramsString = "";
    const entries = Object.entries(obj);
    entries.forEach(([key, value], index) => {
        if (value) {
            index === 0 ? (paramsString += `${key}=${value}`) : (paramsString += `&${key}=${value}`);
        }
    });
    return paramsString;
}
